module.exports = __webpack_public_path__ + "img/meat-on-bone.fc10ada0.png";